// extracted by mini-css-extract-plugin
export default {"container":"MainBody_container__6gmhq","reciever":"MainBody_reciever__qqRbL","sender":"MainBody_sender__uqQ+-","time":"MainBody_time__nKgJV","owner":"MainBody_owner__ORKu+"};